import { DialogAccessCredentials, ModalParts } from 'BreetComponents';
import { OTPLENGTH } from 'BreetHelpers';
import { useAccessCredentials, useAutoSettlementApi, useFormStage } from 'BreetHooks';
import { selectSelectedBeneficiary, useAppSelector, useGetBeneficiariesQuery } from 'BreetRedux';
import { useCallback } from 'react';

import Destination from './DialogAutomaticSettlement.Destination';
import { type AUTOSETTLEMENTSTAGE, autoSettlementStageTitle } from './DialogAutomaticSettlement.helpers';

const DialogAutomaticSettlement = () => {
	useGetBeneficiariesQuery();

	const selectedBeneficiary = useAppSelector(selectSelectedBeneficiary);

	const { isStageActive, navigator, stageTitle } = useFormStage<AUTOSETTLEMENTSTAGE>(
		'destination',
		['destination', 'otpverification'],
		autoSettlementStageTitle
	);

	const handleAutomaticSettlement = useAutoSettlementApi({
		accountName: selectedBeneficiary?.accountName ?? '',
		accountNumber: selectedBeneficiary?.accountNumber ?? '',
		bankName: selectedBeneficiary?.bankName ?? '',
		id: selectedBeneficiary?._id ?? '',
		autoSettlement: selectedBeneficiary?.autoSettlement,
	});

	const { component, handleVerification } = useAccessCredentials({
		id: 'automatic-settlement',
		mode: 'otp',
		submitRequest: handleAutomaticSettlement,
		closeModalId: 'autoSettlement',
		dialogMessage: 'Processing request...',
		description: `Enter the ${OTPLENGTH}-digit OTP sent to enable automatic settlement.`,
		type: 'verify',
		render: (props) => <DialogAccessCredentials {...props} />,
	});

	const handleUpdateAutoSettlement = useCallback(() => {
		handleVerification();
		navigator.goTo('otpverification')();
	}, [handleVerification, navigator]);

	return (
		<ModalParts.Wrapper
			title={stageTitle}
			handleBackLink={navigator.prev}
			wrapperClassName='automaticsettlement bg-primary-500'
			root={autoSettlementStageTitle.destination}
		>
			<ModalParts.Stage hide={!isStageActive('destination')}>
				<Destination
					updateAutoSettlement={handleUpdateAutoSettlement}
					selectedBeneficiary={selectedBeneficiary}
				/>
			</ModalParts.Stage>

			<ModalParts.Stage hide={!isStageActive('otpverification')}>{component}</ModalParts.Stage>
		</ModalParts.Wrapper>
	);
};

export default DialogAutomaticSettlement;
